<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog" persistent max-width="500px" :retain-focus="false" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span class="headline">Atenção</span>

          <v-spacer />

          <v-btn color="#000" icon style="margin-left: -10px" @click="fechar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-5">
          <p v-for="(error, i) in errors" :key="i">{{ error }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'DialogError.vue',
    props: ["dialog", "errors"],
    methods: {
      fechar: function () {
        this.$emit("fechar")
      }
    }
  }
</script>
